import WebFooterSFC from "./WebFooter.vue";
export const WebFooter = WebFooterSFC;
